import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAnalytics } from '../../../hooks/useAnalytics';
import Compass from './Compass';
import CompassEditor from './CompassEditor';
import './CompassView.css';

export default function CompassView() {
  const { trackModuleAccess } = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    // Track module access
    const view = location.pathname.includes('/editor') ? 'editor' : 'Saved Notes';
    trackModuleAccess('compass', {
      plan: 'team',
      initial_view: view
    });
  }, [location.pathname, trackModuleAccess]);

  return (
    <div className="compass-view" style={{ background: '#F7F9FC', minHeight: '100vh', width: '100%'}} >
      <Routes>
        <Route index element={<Navigate to="saved-notes" replace />} />
        <Route path="saved-notes" element={<Compass />} />
        <Route path="saved-notes/editor" element={<CompassEditor />} />
        <Route path="editor" element={<CompassEditor />} />
      </Routes>
    </div>
  );
} 